import qs from 'qs';

import type { SubEnvironment } from '@change-corgi/config/environments';
import { getFacebookAppId as getFacebookAppIdBase } from '@change-corgi/config/facebook';
import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

function getFacebookAppId({ environment }: UtilityContext): string {
	const env = (environment.getDemoEnvironment() || environment.getEnvironment()) as SubEnvironment;
	return getFacebookAppIdBase(env) || getFacebookAppIdBase('development');
}

export function shareFacebookMessenger(
	url: string,
	{ trackingEvents, trackingData }: Options,
	utilityContext: UtilityContext,
	track: TrackingFn,
): void {
	openUrlWithHiddenAnchor(
		`fb-messenger://share/?${qs.stringify(
			{ link: url, app_id: getFacebookAppId(utilityContext) },
			{ encodeValuesOnly: true },
		)}`,
	);
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
